import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

function Teste() {

  const [state, setState] = useState({ left: 0, top: 0, width: 100, height: 100, visualViewporHeight: 0, visualViewporWidth: 0 });

  useEffect(() => {

    function handleWindowMouseMove(e) {
      // Espalhando "...state" garante que width e height não se "percam"

      let screenObj = window.screen;

      let visualViewport = window.visualViewport;

      setState(state => ({
        ...state,
        left: e.pageX,
        top: e.pageY,
        visualViewporHeight: visualViewport.height,
        visualViewporWidth: visualViewport.width,

      }));
    }
    // Nota: essa implementação é um pouco simplificada


    window.addEventListener('mousemove', handleWindowMouseMove);

    return () => window.removeEventListener('mousemove', handleWindowMouseMove);
  }, []);

  useEffect(() => {

    var bottomBar = document.getElementById('bottombar');
    var viewport = window.visualViewport;
    function viewportHandler() {
      var layoutViewport = document.getElementById('layoutViewport');

      // Since the bar is position: fixed we need to offset it by the visual
      // viewport's offset from the layout viewport origin.
      var offsetLeft = viewport.offsetLeft;
      var offsetTop = viewport.height
        - layoutViewport.getBoundingClientRect().height
        + viewport.offsetTop;

      // You could also do this by setting style.left and style.top if you
      // use width: 100% instead.
      bottomBar.style.transform = 'translate(' +
        offsetLeft + 'px,' +
        offsetTop + 'px) ' +
        'scale(' + 1 / viewport.scale + ')'
    }
    window.visualViewport.addEventListener('scroll', viewportHandler);
    window.visualViewport.addEventListener('resize', viewportHandler);


  }, []);




  useEffect(() => {

    let bottomBar = document.getElementById('bottombar');
    let viewport = window.visualViewport;


    function viewportlocal(e) {
      viewportHandlerBootom(e);
      viewportHandler(e);
    }



    function viewportHandlerBootom(e) {
      var layoutViewport = document.getElementById('layoutViewport');

      // Since the bar is position: fixed we need to offset it by the visual
      // viewport's offset from the layout viewport origin.
      var offsetLeft = viewport.offsetLeft;
      var offsetTop = viewport.height
                  - layoutViewport.getBoundingClientRect().height
                  + viewport.offsetTop;

      offsetTop = offsetTop - 100;

      // You could also do this by setting style.left and style.top if you
      // use width: 100% instead.
      bottomBar.style.transform = 'translate(' +
                                  offsetLeft + 'px,' +
                                  offsetTop + 'px) ' +
                                  'scale(' + 1/viewport.scale + ')'
    }


    function viewportHandler(e) {
      // Espalhando "...state" garante que width e height não se "percam"
      let visualViewport = window.visualViewport;
      setState(state => ({
        ...state,
        visualViewporHeight: visualViewport.height,
        visualViewporWidth: visualViewport.width,
      }));
    }
    // Nota: essa implementação é um pouco simplificada


    window.visualViewport.addEventListener('scroll', viewportlocal);
    window.visualViewport.addEventListener('resize', viewportlocal);

    return () => {
      window.visualViewport.removeEventListener('scroll', viewportlocal)
      window.visualViewport.removeEventListener('resize', viewportlocal)
    }
      ;
  }, []);




  return (

    <>
      <h1>left - {state.left}</h1>
      <h1>top - {state.top}</h1>
      <h1>width - {state.width}</h1>
      <h1>height - {state.height}</h1>
      <h1>visualViewporHeight - {state.visualViewporHeight}</h1>
      <h1>visualViewporWidth - {state.visualViewporWidth}</h1>

      <div id="bottombar">
        <div id="layoutViewport">
          dagno costa ferreira lopes
        </div>
      </div>

    </>

  );
}

export default Teste;
